import React from 'react';

import {svg} from '../assets/svg';

type Props = {
  title: string;
  viewAllVisible?: boolean;
  viewAllOnClick?: () => void;
  containerStyle?: React.CSSProperties;
};

export const BlockHeading: React.FC<Props> = ({
  title,
  viewAllOnClick,
  containerStyle,
  viewAllVisible = false,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        ...containerStyle,
      }}
      className='row-center-space-between'
    >
      <h4
        className='number-of-lines-1'
        style={{
          textTransform: 'capitalize',
          margin: 0,
          fontSize: 20,
          fontWeight: 700,
          color: 'var(--main-color)',
          letterSpacing: '-0.3px',
          fontFamily: 'DM Sans, sans-serif',
        }}
      >
        {title}
      </h4>
      {viewAllOnClick && (
        <button
          onClick={viewAllOnClick}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '4px 8px',
            borderRadius: 8,
            transition: 'background-color 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(0, 176, 185, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <svg.ViewAllSvg />
        </button>
      )}
    </div>
  );
};
